import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'

const LOADING_MESSAGES = [
  'Warming up your inbox',
  'Sorting priorities',
  'Reviewing your schedule',
  'Catching up on emails',
  'Preparing your briefing',
  'Checking follow-ups',
  'Getting things in order',
  'Almost ready',
]

/** Animated TendBot logo splash — used for loading and auth-check states. */
export default function SplashScreen() {
  const [messageIndex, setMessageIndex] = useState(() =>
    Math.floor(Math.random() * LOADING_MESSAGES.length)
  )
  const [dots, setDots] = useState(0)

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setMessageIndex(prev => {
        let next: number
        do {
          next = Math.floor(Math.random() * LOADING_MESSAGES.length)
        } while (next === prev && LOADING_MESSAGES.length > 1)
        return next
      })
    }, 3000)

    const dotsInterval = setInterval(() => {
      setDots(prev => (prev + 1) % 4)
    }, 500)

    return () => {
      clearInterval(messageInterval)
      clearInterval(dotsInterval)
    }
  }, [])

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center">
      {/* Ambient gold glow behind logo */}
      <motion.div
        className="absolute rounded-full"
        style={{
          width: 200,
          height: 200,
          background: 'radial-gradient(circle, rgba(200,149,48,0.08) 0%, rgba(200,149,48,0.03) 40%, transparent 70%)',
        }}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      />

      {/* Logo */}
      <motion.img
        src="/tendbot.png"
        alt="TendBot"
        className="h-16 w-auto relative"
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      />

      {/* Loading message */}
      <div className="h-6 mt-8 relative">
        <AnimatePresence mode="wait">
          <motion.p
            key={messageIndex}
            className="text-pearl/55 text-[13px] tracking-wide font-light whitespace-nowrap"
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            {LOADING_MESSAGES[messageIndex]}{'.'.repeat(dots)}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  )
}
